module.exports = __webpack_public_path__ + "img/brand-cases15.9dde27be.png";